<template>
  <div class="w-100 d-flex justify-content-center">
    <div class="goal-tabs-section col-12 col-lg-10">
      <div class="tabs d-flex mt-1">
        <div class=" d-flex text-normal">
          <span
            class="tab mr-2"
            :class="{ 'selected-tab': selectedTab === 'EVENTS' }"
            @click="selectedTab = 'EVENTS'"
          >
            Goal Activity
          </span>
          <span
            class="tab"
            :class="{ 'selected-tab': selectedTab === 'CHILD_GOALS' }"
            @click="selectedTab = 'CHILD_GOALS'"
          >
            Child Goals
          </span>
        </div>
        <feeds-heading
          class="ml-2 text-medium"
          :entity-type="ENTITY_TYPE.GOAL"
          :selected-filter="selectedFilter"
          v-if="selectedTab === 'EVENTS'"
        />
      </div>
      <div class="row activity-discussion-container">
        <div class="activity-discussion col-12 flex-grow-1" v-if="selectedTab === 'EVENTS'">
          <goal-activity-section
            :event-to-focus="eventToFocus"
            :goal="goal"
            :key="'activity-' + goal.id"
            :selected-activity-filter="selectedFilter"
          />
        </div>
        <keep-alive>
          <child-goals
            :org-id="goal.organizationId"
            :goal-id="goal.id"
            v-if="selectedTab === 'CHILD_GOALS'"
          />
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import ChildGoals from '@/components/ChildGoals'
import GoalActivitySection from '@/components/GoalActivitySection'
import FeedsHeading from '@/components/FeedsHeading'
import { ENTITY_TYPE } from '@/constants/entities'

/**
 *This component shows Goal's activities - checkins and comments
 */
export default {
  name: 'GoalActivityAndChildGoals',
  props: ['goal', 'eventToFocus'],
  components: {
    GoalActivitySection,
    ChildGoals,
    FeedsHeading
  },
  data() {
    return {
      selectedTab: 'EVENTS'
    }
  },
  computed: {
    ENTITY_TYPE() {
      return ENTITY_TYPE
    },
    selectedFilter() {
      return this.$store.getters['feedPreference/selectedFilter'](ENTITY_TYPE.GOAL)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.tab {
  cursor: pointer;
  padding: 5px 16px;
  border-radius: 16px;
  color: $secondary;
}
.tab.selected-tab {
  background-color: $quinary;
  color: $primary;
  font-weight: 600;
}

.tabs {
  margin-bottom: 25px;
  align-items: center;
}
.activity-discussion {
  margin-bottom: 20px;
}
.goal-tabs-section {
  margin-bottom: 30px;
}
@include media-breakpoint-down(md) {
  .activity-discussion-container {
    margin: 0;
  }
  .activity-discussion {
    padding: 0;
    min-width: 0;
  }
  .goal-tabs-section {
    margin: 12px 0 !important;
    padding: 0 !important;
  }
  .tabs {
    padding: 0;
  }
  /deep/ .child-goals {
    padding: 0;
    .skeleton-loader {
      padding-left: 0;
    }
    .child-goal {
      margin: 0;
    }
  }
}
</style>
